import { ClassNames } from '@emotion/react';
import { Button } from 'antd';
import { ERROR_BOUNDARY_COPY } from './constants';
import {
  actionsStyles,
  cardStyles,
  descriptionStyles,
  rootStyles,
  titleStyles,
} from './styles';

interface ErrorBoundaryFallbackProps {
  onRetry: () => void;
}

const ErrorBoundaryFallback = ({ onRetry }: ErrorBoundaryFallbackProps) => (
  <ClassNames>
    {({ css }) => (
      <div className={css(rootStyles)} role="alert" aria-live="assertive">
        <div className={css(cardStyles)}>
          <h1 className={css(titleStyles)}>{ERROR_BOUNDARY_COPY.title}</h1>
          <p className={css(descriptionStyles)}>
            {ERROR_BOUNDARY_COPY.description}
          </p>
          <div className={css(actionsStyles)}>
            <Button type="primary" onClick={onRetry}>
              {ERROR_BOUNDARY_COPY.retryLabel}
            </Button>
          </div>
        </div>
      </div>
    )}
  </ClassNames>
);

export default ErrorBoundaryFallback;
